import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=d679c4d4&"
import script from "./FooterInfo.vue?vue&type=script&lang=js&"
export * from "./FooterInfo.vue?vue&type=script&lang=js&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=d679c4d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports